'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center p-5 bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
        <h2 className="text-2xl font-bold text-[#900f21] mb-4">Something went wrong</h2>
        <p className="text-gray-600 mb-6">
          An error occurred while trying to load this page. Please try again later.
        </p>
        <button
          onClick={reset}
          className="bg-[#900f21] text-white font-medium py-2 px-4 rounded-md hover:bg-[#7a0c1c] transition-colors"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
